import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Zap, LayoutDashboard, LogOut, Shield } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/80 backdrop-blur-xl">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="w-9 h-9 rounded-xl bg-blue-600 flex items-center justify-center">
            <Zap className="w-5 h-5 text-white" fill="white" />
          </span>
          <span className="font-display text-lg font-extrabold tracking-tight">kisalink<span className="text-blue-600">.net</span></span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-3">
          {user && user.role === "admin" && (
            <Button variant="ghost" size="sm" onClick={() => navigate("/link")} data-testid="nav-admin">
              <Shield className="w-4 h-4 mr-1" /> Admin
            </Button>
          )}
          {user ? (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/dashboard")} data-testid="nav-dashboard">
                <LayoutDashboard className="w-4 h-4 mr-1" /> Panel
              </Button>
              <Button variant="outline" size="sm" onClick={async () => { await logout(); navigate("/"); }} data-testid="nav-logout">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/login")} data-testid="nav-login">Giriş</Button>
              <Button size="sm" className="bg-blue-600 hover:bg-blue-700" onClick={() => navigate("/register")} data-testid="nav-register">
                Ücretsiz Başla
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
